// ReplyComposer yardımcıları (saf fonksiyonlar).

const EMAIL_RE = /^[^\s@<>,;]+@[^\s@<>,;]+\.[^\s@<>,;]+$/;

export const isValidEmail = value => EMAIL_RE.test((value || '').trim());

/** Idempotency-Key üretir (crypto.randomUUID yoksa getRandomValues, o da yoksa Math.random). */
export const newIdempotencyKey = () => {
  const c = typeof window !== 'undefined' ? window.crypto : null;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  const bytes = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') {
    c.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, b => `0${b.toString(16)}`.slice(-2)).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

/** Gönderim yükünün parmak izi: içerik değişirse yeni Idempotency-Key gerekir. */
export const payloadFingerprint = (messageId, p) =>
  JSON.stringify([
    messageId,
    p.toRecipients,
    p.ccRecipients,
    p.subject,
    p.bodyText,
    (p.attachments || []).map(a => [a.fileName, a.contentBase64.length])
  ]);

export const replySubject = subject => {
  const s = (subject || '').trim();
  if (!s) return 'Re:';
  return /^(re|ynt|aw|sv)\s*:/i.test(s) ? s : `Re: ${s}`;
};

const addrs = list => (list || []).map(r => r && r.address).filter(Boolean);

const unique = list => list.filter((a, i) => list.findIndex(b => b.toLowerCase() === a.toLowerCase()) === i);

/**
 * Varsayılan alıcılar (contract/agent-api-usage.md §2.4: defaultReplyCc / defaultReplyAllCc).
 * Giden (Outbound) mesaja cevapta alıcı, o mesajın alıcılarıdır.
 */
export const defaultRecipients = (message, mode) => {
  const outbound = message.direction === 'Outbound';
  const to = outbound ? addrs(message.toRecipients) : [message.senderAddress].filter(Boolean);
  const cc = mode === 'replyAll' ? addrs(message.defaultReplyAllCc) : addrs(message.defaultReplyCc);
  const toU = unique(to);
  return {
    to: toU,
    cc: unique(cc).filter(a => !toU.some(x => x.toLowerCase() === a.toLowerCase()))
  };
};

/** Ek politikası (AttachmentPolicyDto). Alanlar yoksa o kural uygulanmaz. */
export const checkAttachment = (file, current, policy) => {
  const p = policy || {};
  if (p.maxAttachmentCount > 0 && current.length + 1 > p.maxAttachmentCount) return 'attach_too_many';
  if (p.maxAttachmentBytes > 0 && file.size > p.maxAttachmentBytes) return 'attach_too_large';
  const total = current.reduce((s, a) => s + a.size, 0) + file.size;
  if (p.maxTotalAttachmentBytes > 0 && total > p.maxTotalAttachmentBytes) return 'attach_total_too_large';
  const allowed = (p.allowedExtensions || []).map(e => e.replace(/^\./, '').toLowerCase());
  if (allowed.length) {
    const dot = file.name.lastIndexOf('.');
    const ext = dot >= 0 ? file.name.slice(dot + 1).toLowerCase() : '';
    if (!allowed.includes(ext)) return 'attach_type_not_allowed';
  }
  return null;
};

export const readFileAsBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => {
      const result = String(reader.result || '');
      resolve(result.slice(result.indexOf(',') + 1));
    };
    reader.readAsDataURL(file);
  });

export const isSafeWebLink = url => /^https?:\/\//i.test(url || '');
